import React from 'react';
import './index.scss';


 const ArrowIcon = (props) => {
    const {
        direction ='right',
        change=false,
        changeDirection='down',
        size=24,
        color,
        className='',
        id='',
        product='racing',
        onClick,
        style={},
        testid
    }=props;
    
    const onHandleClick = () =>{
        onClick && onClick();
    }
    return (
        <div data-testid={testid} id={`${id}`} className={`${className} arrow-icon arrow-icon-default${color?`-${color}`:''}-${direction} ${change && `arrow-icon-change-${changeDirection}`}`} style={{minWidth:`${size}px`, maxWidth:`${size}px`, height:`${size}px`,...style}} onClick={onHandleClick}>

        </div>
    );
};

export default ArrowIcon